import { ILegalTransactionRelationship } from '../../../../Interfaces/ILegalTransactionRelationship/ILegalTransactionRelationship';
import { ILegalTransactionRelationshipMember } from '../../../../Interfaces/ILegalTransactionRelationship/ILegalTransactionRelationshipMember';
import { LegalTransactionRelationshipRoleEnum } from '../../../../Interfaces/ILegalTransactionRelationship/LegalTransactionRelationshipRoleEnum';
import { LegalTransactionRelationshipTypeEnum } from '../../../../Interfaces/ILegalTransactionRelationship/LegalTransactionRelationshipTypeEnum';
import { IMemberSpouse } from '../../../../Interfaces/ILegalTransactionRelationship/Members/IMemberSpouse';
import { IMemberTestator } from '../../../../Interfaces/ILegalTransactionRelationship/Members/IMemberTestament';
import { IFamilyRelationship } from '../../../../Interfaces/ILegalTransactionRelationship/Relationships/Family/ILegalTransactionFamilyRelationship';
import { IMarriageRelationship } from '../../../../Interfaces/ILegalTransactionRelationship/Relationships/Marriage/ILegalTransactionRelationshipMarriage';
import { ITestamentRelationship } from '../../../../Interfaces/ILegalTransactionRelationship/Relationships/Testament/ILegalTransactionRelationshipTestament';
import {
  getOrCreateSingletonRelationship,
  getRelationshipsByLegalClient,
} from '../generic/utilities';

export const getOrCreateCurrentMarriageRelationship = (
  relationshipArray: ILegalTransactionRelationship[]
): IMarriageRelationship => {
  return getOrCreateSingletonRelationship(
    relationshipArray,
    LegalTransactionRelationshipTypeEnum.Marriage,
    rel => isMarriageRelationship(rel) && rel.data.divorceDate === null
  );
};

export const getOrCreateTestamentRelationship = (
  relationshipArray: ILegalTransactionRelationship[]
): ITestamentRelationship => {
  return getOrCreateSingletonRelationship(
    relationshipArray,
    LegalTransactionRelationshipTypeEnum.Testament
  );
};

export const isTestatorMember = (
  member: ILegalTransactionRelationshipMember | undefined
): member is IMemberTestator => {
  return (
    !!member &&
    member.idRelationshipRole === LegalTransactionRelationshipRoleEnum.Testator
  );
};

export const createMarriageRelationship = (
  relationshipArray: ILegalTransactionRelationship[]
): ILegalTransactionRelationship => {
  return getOrCreateSingletonRelationship(
    relationshipArray,
    LegalTransactionRelationshipTypeEnum.Marriage
  );
};

export const getMarriageRelationshipsByLegalClient = (
  relationshipArray: ILegalTransactionRelationship[],
  idLegalClient: number
): IMarriageRelationship[] => {
  return (
    getRelationshipsByLegalClient(relationshipArray, idLegalClient)?.filter(
      isMarriageRelationship
    ) || []
  );
};

export const isSpouseMember = (
  member: ILegalTransactionRelationshipMember | undefined
): member is IMemberSpouse => {
  return (
    !!member &&
    member.idRelationshipRole === LegalTransactionRelationshipRoleEnum.Spouse
  );
};

export const isMarriageRelationship = (
  relationship: ILegalTransactionRelationship | undefined
): relationship is IMarriageRelationship => {
  return (
    !!relationship &&
    relationship.idRelationshipType ===
      LegalTransactionRelationshipTypeEnum.Marriage
  );
};

export const isFamilyRelationship = (
  relationship: ILegalTransactionRelationship | undefined
): relationship is IFamilyRelationship => {
  return (
    !!relationship &&
    relationship.idRelationshipType ===
      LegalTransactionRelationshipTypeEnum.Family
  );
};
